import React, { useState } from "react";

export const ReadMore = ({ text, textStyle, trimLength = 100 }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  const dotDotDot = text.length > trimLength ? "..." : "";
  const displayText = expanded
    ? text
    : `${text.slice(0, trimLength)}${dotDotDot}`;

  return (
    <div>
      <p style={textStyle}>{displayText}</p>
      {text.length > trimLength && (
        <button
          onClick={toggleExpanded}
          className="usa-button usa-button--unstyled"
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};
